import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitValue, UnitValueControl } from 'src/app/form-controls/unit-value/unit-value.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { FluidsInfusionActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface FluidsInfusionActionFormGroup {
	rate: FormControl<UnitValue | null>;
}

@Component({
    selector: 'app-fluids-infusion-action-controls-v2',
    templateUrl: './fluids-infusion-action-controls-v2.component.html',
    styleUrls: ['../../../common.scss', './fluids-infusion-action-controls-v2.component.scss'],
    imports: [ReactiveFormsModule, UnitValueControl, CommonActionControlsComponent, ActionFormComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FluidsInfusionActionControlsComponentV2 implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: FluidsInfusionActionV2;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as FluidsInfusionActionV2;
	}

	@Input() form!: FormGroup<FluidsInfusionActionFormGroup>;
	@Input() item!: Row | null;
	
	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('rate', this.formBuilder.control(this.action?.rate ?? null));
	}
}